<template>
  <section>
    <form method="post" @submit.prevent="send" novalidate>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title is-centered">
            {{ $t('attributes.add') + $t('attributes.catalog') }}
          </p>
        </header>
        <section class="modal-card-body">
          <form-wrapper :validator="$v.form">
            <form-group
              horizontal
              name="area_code"
              attribute="attributes.area"
              :label="$t('attributes.area')"
            >
              <b-select
                v-model="selectedArea"
                name="area_code"
                :loading="loadingAreas"
                :placeholder="
                  $t('message.please_select') + $t('attributes.area')
                "
                expanded
                @input="onSelectArea"
              >
                <option value="" disabled>
                  {{ $t('message.please_select') + $t('attributes.area') }}
                </option>
                <option
                  v-for="option in areas"
                  :key="option.code"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="catalog_no"
              attribute="attributes.catalog_code"
              :label="$t('attributes.catalog_code')"
            >
              <b-input
                v-model="form.catalog_no"
                name="catalog_no"
                maxlength="3"
                :has-counter="false"
                :placeholder="
                  $t('message.please_input') + $t('attributes.catalog_code')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group horizontal name="name" :label="$t('attributes.name')">
              <b-input
                v-model="form.name"
                name="name"
                :placeholder="
                  $t('message.please_input') + $t('attributes.name')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="description"
              :label="$t('attributes.description')"
            >
              <b-input
                v-model="form.description"
                type="textarea"
                name="description"
                :placeholder="
                  $t('message.please_input') + $t('attributes.description')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="email"
              :label="$t('attributes.order_email')"
            >
              <b-input
                v-model="form.email"
                name="email"
                :placeholder="
                  $t('message.please_input') + $t('attributes.email')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="link"
              attribute="attributes.external_url"
              :label="$t('attributes.external_url')"
            >
              <b-input
                v-model="form.link"
                name="link"
                :placeholder="
                  $t('message.please_input') + $t('attributes.external_url')
                "
                expanded
              ></b-input>
            </form-group>

            <form-group
              horizontal
              name="status"
              attribute="attributes.status"
              :label="$t('attributes.status')"
            >
              <b-switch v-model="form.status" name="status"></b-switch>
            </form-group>

            <form-group horizontal name="sort" :label="$t('attributes.sort')">
              <b-select v-model="form.sort" name="sort">
                <option
                  v-for="option in sortOptions"
                  :key="option"
                  :value="option"
                >
                  {{ option }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="is_home"
              :label="$t('attributes.catalog_is_home')"
            >
              <b-select v-model="form.is_home" name="is_home" expanded>
                <option value="true">{{ $t('attributes.display') }}</option>
                <option value="false">{{ $t('attributes.hide') }}</option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="is_sub_home"
              :label="$t('attributes.catalog_is_sub_home')"
            >
              <b-select v-model="form.is_sub_home" name="is_sub_home" expanded>
                <option value="true">{{ $t('attributes.display') }}</option>
                <option value="false">{{ $t('attributes.hide') }}</option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="product_list_type"
              :label="
                $t('attributes.catalog_is_sub_home') +
                  $t('attributes.product') +
                  $t('attributes.display')
              "
            >
              <b-select
                v-model="form.product_list_type"
                name="product_list_type"
                expanded
              >
                <option value="0">
                  {{ $t('attributes.product_type_graphic') }}
                </option>
                <option value="1">
                  {{ $t('attributes.product_type_text') }}
                </option>
              </b-select>
            </form-group>

            <form-group
              horizontal
              name="picture"
              attribute="attributes.catalog_cover"
              grouped
            >
              <template #label>
                {{ $t('attributes.catalog_cover') }}
                <b-tooltip type="is-danger" label="600*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    icon="help-circle-outline"
                    type="is-danger"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a
                  class="button is-primary"
                  :disabled="!selectedArea"
                  @click="onSelectCoverImage"
                >
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="CatalogImage(form.picture)"
                    @click.prevent="onClickImage(CatalogImage(form.picture))"
                  >
                    {{ form.picture }}
                  </a>
                </p>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="operation_picture"
              attribute="attributes.operation_picture"
              grouped
            >
              <template #label>
                {{ $t('attributes.operation_picture') }}
                <b-tooltip type="is-danger" label="1920*400/限定jpg檔，600KB內">
                  <b-icon
                    size="is-small"
                    icon="help-circle-outline"
                    type="is-danger"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a
                  class="button is-primary"
                  :disabled="!selectedArea"
                  @click="onSelectOperationPictureImage"
                >
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.operation_picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="CatalogImage(form.operation_picture)"
                    @click.prevent="
                      onClickImage(CatalogImage(form.operation_picture))
                    "
                  >
                    {{ form.operation_picture }}
                  </a>
                </p>
              </b-field>
            </form-group>

            <form-group
              horizontal
              name="operation_mobile_picture"
              attribute="attributes.operation_mobile_picture"
              grouped
            >
              <template #label>
                {{ $t('attributes.operation_mobile_picture') }}
                <b-tooltip type="is-danger" label="600*400/限定jpg檔，100KB內">
                  <b-icon
                    size="is-small"
                    icon="help-circle-outline"
                    type="is-danger"
                  ></b-icon>
                </b-tooltip>
              </template>
              <b-field class="file">
                <a
                  class="button is-primary"
                  :disabled="!selectedArea"
                  @click="onSelectOperationMobilePictureImage"
                >
                  <b-icon icon="upload"></b-icon>
                  <span>{{ $t('message.please_select_file') }}</span>
                </a>
                <p
                  v-if="form.operation_mobile_picture"
                  class="tag is-warning"
                  style="margin-left: 4px; height: 40px"
                >
                  <a
                    :href="CatalogImage(form.operation_mobile_picture)"
                    @click.prevent="
                      onClickImage(CatalogImage(form.operation_mobile_picture))
                    "
                  >
                    {{ form.operation_mobile_picture }}
                  </a>
                </p>
              </b-field>
            </form-group>
          </form-wrapper>
        </section>

        <footer class="modal-card-foot">
          <b-button :loading="isSending" @click="$parent.close()">
            {{ $t('attributes.cancel') }}
          </b-button>
          <b-button
            :loading="isSending || isLoading"
            type="is-primary"
            native-type="submit"
          >
            {{ $t('attributes.add') }}
          </b-button>
        </footer>
      </div>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="CatalogImage(selectedImageUrl)" alt="" />
      </p>
    </b-modal>

    <b-loading :active.sync="isLoading" :can-cancel="false"></b-loading>
  </section>
</template>

<script>
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import { AREA_API } from '@/utils/apis'
import {
  OpenCatalogCoverFinder,
  OpenCatalogOperationFinder
} from '@/utils/ckfinder'
import notifyService from '@/services/notifyService'

export default {
  name: 'CreateForm',

  props: {
    isSending: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loadingAreas: false,
      areas: [],
      selectedArea: null,

      form: {
        catalog_no: '',
        area_code: null,
        sort: 1,
        status: true,
        name: '',
        description: '',
        email: '',
        link: '',
        is_home: true,
        is_sub_home: true,
        picture: null,
        operation_picture: null,
        operation_mobile_picture: null,
        product_list_type: 0
      },

      sortOptions: [...Array(50).keys()].map(i => i + 1),

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      catalog_no: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(3)
      },
      area_code: { required },
      sort: { required },
      status: { required },
      name: { required, maxLength: maxLength(30) },
      description: { maxLength: maxLength(500) },
      email: { maxLength: maxLength(100) },
      link: { maxLength: maxLength(500) },
      is_home: { required },
      is_sub_home: { required },
      picture: {},
      operation_picture: {},
      operation_mobile_picture: {},
      product_list_type: { required }
    }
  },
  computed: {
    isLoading() {
      return this.loadingAreas
    }
  },
  mounted() {
    this.loadAreas()
  },
  methods: {
    async loadAreas() {
      try {
        this.loadingAreas = true
        const res = await this.axios.get(AREA_API)
        const areas = res.data.data
        this.areas = areas.sort(a => a.sort)
        this.selectedArea = null
      } catch (e) {
        this.areas = []
        this.selectedArea = null

        notifyService.fetch_error('area', e)
      } finally {
        this.loadingAreas = false
      }
    },
    onSelectArea(option) {
      this.form.area_code = option && option.code
    },
    async onSelectCoverImage() {
      if (!this.selectedArea) {
        return
      }

      try {
        this.form.picture = await OpenCatalogCoverFinder(
          this.selectedArea.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectOperationPictureImage() {
      try {
        this.form.operation_picture = await OpenCatalogOperationFinder(
          this.selectedArea.image_path
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSelectOperationMobilePictureImage() {
      try {
        this.form.operation_mobile_picture = await OpenCatalogOperationFinder(
          this.selectedArea.image_path,
          true
        )
      } catch (e) {
        notifyService.error(e)
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = url
    },
    send() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('onSend', this.form)
    }
  }
}
</script>
